import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {DeviceService} from '../../shared/services/device/device.service';
import {StatesService} from '../../shared/services/state/states.service';
import {forkJoin, Subscription} from 'rxjs/index';
import {map} from 'rxjs/internal/operators';
import {ReferentialService} from '../../shared/services/referential/referential.service';
import {TranslateService} from '@ngx-translate/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SchedulerSpcuComponent} from '../../shared/components/scheduler-spcu/scheduler-spcu.component';
import {DeviceBatchActionComponent} from '../../shared/components/device/device-batch-action/device-batch-action.component';
import {AuthenticationService} from '../../shared/services/authentication/authentication.service';
import {ModalService} from '../../shared/services/modal/modal.service';
import {AbstractMatTable} from '../../shared/classes/mat-table/abstract-mat-table';
import {IconService} from '../../shared/services/icon/icon.service';
import CRUD_MODE = CrudConstants.CRUD_MODE;
import {CrudConstants} from '../../shared/constants/crud.constants';

@Component({
  selector: 'app-device',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.css']
})
export class DevicesComponent extends AbstractMatTable implements OnInit, OnDestroy {

  readonly CRUD_MODE = CRUD_MODE;
  public activeDevice: boolean = true;
  public availableDevice: boolean = false;
  public devicesMultiLevel: boolean = false;
  public reloadListDevices: Subscription;
  public deviceTypes;
  public unitList;
  public deviceTypeSelected: number = 1;
  public filter: string = '';
  public batchList: number[] = [];
  public batchImportsAvailable: boolean;
  public levelSubscription: Subscription;


  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private deviceService: DeviceService,
              private referentialService: ReferentialService,
              public statesService: StatesService,
              private translate: TranslateService,
              private modalService: ModalService,
              public activeModal: NgbActiveModal,
              public authenticationService: AuthenticationService,
              public iconService: IconService) {
    super();
  }

  ngOnInit() {
    this.batchImportsAvailable = this.authenticationService.userHasRoleProduction() && this.authenticationService.userIsLevelZero();
    this.levelSubscription = this.statesService.stateLevelChangedSubject
      .subscribe(() => this.getListDevices()
      );
    this.reloadListDevices = this.statesService.reloadListDevices
      .subscribe(() => this.getListDevices()
      );
    this.showSpinner = true;
    forkJoin(
      this.referentialService.getDeviceTypes().pipe(map((data: any) => {
          data.forEach((d) => {
            d.value = d.id;
            delete d.id;
            d.name = d.type;
            delete d.type;
          });
          return data;
        })
      ),
      this.referentialService.getUnits(),
    ).subscribe((results) => {

      this.deviceTypes = results[0];
      this.unitList = results[1];
      this.showSpinner = false;
      this.getListDevices();
    });

  }

  ngOnDestroy() {
    this.levelSubscription.unsubscribe();
    this.reloadListDevices.unsubscribe();
  }

  reLoadList() {
    this.activeDevice = !this.activeDevice;
    this.statesService.reloadListDevices.next();
  }

  reLoadListAllLevel() {
    this.devicesMultiLevel = !this.devicesMultiLevel;
    this.statesService.reloadListDevices.next();
  }

  availableReloadList() {
    this.availableDevice = !this.availableDevice;
    this.statesService.reloadListDevices.next();
  }

  getTextForSlider(context: number = 1) {
    let value: string = '';
    let falseValue: string = '';
    let trueValue: string = '';
    let referenceValue: boolean = true;
    switch (context) {
      case 1:
        referenceValue = this.devicesMultiLevel;
        falseValue = 'CURRENT_LEVEL';
        trueValue = 'ALL_LEVEL';
        break;
      case 2:
        referenceValue = this.activeDevice;
        falseValue = 'INACTIVE';
        trueValue = 'ACTIVE';
        break;
      case 3:
        referenceValue = this.availableDevice;
        falseValue = 'ALL';
        trueValue = 'AVAILABLE';
        break;

    }
    this.translate.get(referenceValue ? trueValue : falseValue).subscribe((text: string) => {
      value = text;
    });

    return value;
  }

  filterListWith(filterValue: string) {
    this.filter = filterValue;
    this.applyFilter(filterValue);
  }

  openScheduler(deviceId: number) {
    const modalRef = this.modalService.openNgbModal(SchedulerSpcuComponent, {size: 'lg'});
    modalRef.componentInstance.deviceId = deviceId;
  }

  openModalForDevicesBatchAction() {
    const modalRef = this.modalService.openNgbModal(DeviceBatchActionComponent, {size: 'lg'});
    modalRef.componentInstance.devicesList = this.matTableDataSource.data.filter(function (d) {
      return d.selector === true;
    });
  }

  isSchedulable(device) {
    return device.device_type === 'spcu_v5' && device.project_device_assignement;
  }

  getCountSelectedDevices() {
    let items = this.matTableDataSource.data.filter(function (d) {
      return d.selector === true;
    });
    return items.length;
  }

  getListDevices(event = null) {
    if (event) {
      this.deviceTypeSelected = event;
    }
    this.batchList = [];
    this.setMatTable(this.deviceService.getDeviceList(this.statesService.stateLevel, this.activeDevice, this.availableDevice, this.deviceTypeSelected, this.devicesMultiLevel), this.getDisplayedColumn());
  }

  private getDisplayedColumn() {
    let displayedColumns = ['id', 'device_type', 'project_name', 'uid', 'children_device', 'location_name', 'action'];
    if (this.batchImportsAvailable) {
      displayedColumns = displayedColumns.filter(element => element !== 'id');
      displayedColumns.unshift('id', 'level_name');
    }
    if (this.deviceTypeSelected === 11 || this.deviceTypeSelected === 8) {
      displayedColumns.push('extra_action');

    }
    if (this.availableDevice && this.deviceTypeSelected !== 0 && this.deviceTypeSelected !== 12 && this.devicesMultiLevel === false) {
      displayedColumns.unshift('selector');
    }
    return displayedColumns;
  }
}

